var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.unassignedPeople),function(element,i){return _c('drag',{key:i,staticClass:"drag",attrs:{"transferData":{ person: element }}},[_c('person',{attrs:{"label":element.name,"active":element.active !== undefined}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }